export default __webpack_public_path__ + "static/media/Orb Shard.40095d40.jpg";